import FireworksIcon from '../components/icons/FireworksIcon';
import PumpkinIcon from '../components/icons/PumpkinIcon';
import ChristmasIcon from '../components/icons/ChristmasIcon';

// Cada temporada es un objeto con su ventana de fechas. getSeason() elige la
// que corresponde HOY, así que el sitio cambia solo (y se apaga solo al
// terminar) sin tener que acordarse de un deploy el 3 de noviembre.
//
// Para agregar una temporada: crear su ícono en components/icons/ con el mismo
// lenguaje de trazo (PostalStamp), declararla aquí y añadirle su ventana en
// getSeason(). SeasonalBadge y su layout no cambian.
//
// Los textos NO prometen descuentos, existencias ni plazos: son contexto de
// negocio. Una promoción real se agrega aquí cuando exista, no antes.
const FIESTAS = {
    id: 'fiestas',
    eyebrow: 'Temporada alta · Septiembre y octubre',
    title: 'Septiembre y octubre mueven más comida en la calle',
    text: 'Las fiestas patrias, los desfiles y las kermeses escolares disparan la venta en puestos y taquerías, y el ritmo se sostiene hacia los preparativos de Día de Muertos. Asegura tu papel de mayoreo antes de que se agote.',
    Icon: FireworksIcon,
};

const HALLOWEEN = {
    id: 'halloween',
    tone: 'night',
    eyebrow: 'Temporada · Octubre',
    title: 'Octubre es de Halloween y de Día de Muertos',
    text: 'Fiestas de disfraces, dulces, pan de muerto y puestos de temporada: todo se envuelve. Surte con tiempo tu papel de mayoreo para que tu negocio no se quede corto.',
    Icon: PumpkinIcon,
    // Si el catálogo trae el papel impreso de Día de Muertos, la franja lo
    // enlaza; si no, no inventa un botón a la nada.
    productMatch: /muertos/i,
    productLabel: 'Ver papel impreso de Día de Muertos',
};

const NAVIDAD = {
    id: 'navidad',
    tone: 'pino',
    eyebrow: 'Temporada · Diciembre',
    title: 'Posadas, cenas y tamales: diciembre también se envuelve',
    text: 'Entre las posadas, la cena de Nochebuena y los puestos de tamales, buñuelos y ponche, diciembre es de los meses con más movimiento en la cocina. Surte con tiempo tu papel de mayoreo.',
    Icon: ChristmasIcon,
    // Si el catálogo trae el papel navideño, la franja lo enlaza; si no, no
    // inventa un botón a la nada.
    productMatch: /navide/i,
    productLabel: 'Ver el papel navideño',
};

/** Temporada vigente según la fecha, o null si ahora no toca ninguna. */
export function getSeason(now = new Date()) {
    const month = now.getMonth(); // 0 = enero
    const day = now.getDate();
    if (month === 8) return FIESTAS;                         // septiembre
    if (month === 9 || (month === 10 && day <= 2)) return HALLOWEEN; // 1 oct – 2 nov
    // 3 nov – 6 ene (Día de Reyes): las fiestas decembrinas completas.
    if ((month === 10 && day >= 3) || month === 11 || (month === 0 && day <= 6)) return NAVIDAD;
    return null;
}

export const CURRENT_SEASON = getSeason();
